module.exports = __webpack_public_path__ + "img/answer_right.0d7bba8c.png";